export default "__VITE_ASSET__BN7Wywc8__"